module.exports = __webpack_public_path__ + "static/media/b.c10f3f89.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/b.mp3
// module id = 91
// module chunks = 0